// Cal.com handle/event slug — format: "<username>/<event-type-slug>"
export const CAL_LINK = "chris-scibiorek/30min";
export const CAL_NAMESPACE = "30min";

// Cal.com booking URL used for external links (fallback / email CTAs)
export const CAL_BOOKING_URL = `https://cal.com/${CAL_LINK}`;

export const LINKEDIN_URL = "https://www.linkedin.com/in/krzysztofscibiorek";
